// import React from "react";
// import arrowRight from "./../../media/slider-right-arrow.svg";
// export default class PageHeader extends React.PureComponent {
//   render = () => (
//     <div className={`page_header_bg ${this.props.headerClass}`}>
//       <div className="orange_layer" />
//       <div className="container">
//         <div className="navigation_holder">
//           <p className="title">{this.props.pageName}</p>
//           <div className="breadcomp">
//             <span>Ana Sayfa</span> <img alt="" src={arrowRight} />{" "}
//             <span>{this.props.pageName}</span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React from "react";
import arrowRight from "./../../media/slider-right-arrow.svg";
export default class PageHeader extends React.PureComponent {
  render = () => (
    <div
      style={
        this.props.backgroundUrl
          ? {
              backgroundImage: `url(${this.props.backgroundUrl})`
            }
          : null
      }
      className={`page_header_bg ${this.props.headerClass}`}
    >
      <div className="orange_layer" />
      <div className="container">
        <div className="navigation_holder">
          <p className="title">{this.props.pageName}</p>
          <div className="breadcomp">
            <span>Ana Sayfa</span> <img alt="" src={arrowRight} />{" "}
            <span>{this.props.pageName}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
